//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import configureStore from './store';
import Analytics from '@web-solutions/module-analytics';
import Attribution from '@web-solutions/module-attribution';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { initLocalization } from './localization';
import { getMagnusToken } from 'src/store/app/utils';
import packageInfo from '../package.json';
import { APP_LINKS } from 'src/constants/general';
import App from './onboarding/App';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { LocalizationInitializer } from './localization/LocalizationInitializer';
import { PaymentProcessorProvider } from 'core/payment/payment-processor-provider/paymentProcessorContext';
import instance from './onboarding/api/interceptor';

const Root = () => {
  const { store, persistor } = configureStore();
  Analytics.init(getMagnusToken(), packageInfo.version);
  Attribution.init(APP_LINKS);

  const p = new URLSearchParams(window.location.search);

  const flow = p.get('flow');

  if (flow) {
    Analytics.setUserProperty('flow', flow);
  }


  return (
    <StrictMode>
      <Provider store={store}>
        <PaymentProcessorProvider>
          <PersistGate loading={null} persistor={persistor}>
            <LocalizationInitializer />
            <App />
          </PersistGate>
        </PaymentProcessorProvider>
      </Provider>
    </StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
